export enum BonusTypes {
  BONUS_POINTS = 'bonusPoints',
  POINTS_MULTIPLIER = 'pointsMultiplier',
}

export type BonusType = BonusTypes.BONUS_POINTS | BonusTypes.POINTS_MULTIPLIER;
